
export function applyFilter<T>(search: string, items: T[], keys: string[]): T[] {
  if (search == null || search.length === 0) return items;

  const s = search.toLowerCase().split(/\s/).filter(x => x.length > 0);
  if (s.length === 0) return items;
  // console.log(s);
  return items.filter(item => {

    const foundKeys = s.map(searchEntry => {
      if (searchEntry.split(':').length === 2) {
        const searchEntryTuple = searchEntry.split(':');
        return (item[searchEntryTuple[0]] || '').toLocaleLowerCase().includes(searchEntryTuple[1])
          ? searchEntry : null;
      } else {
        return keys.filter(
          key => (item[key] || '').toLocaleLowerCase().includes(searchEntry) )
          .length > 0 ? searchEntry : null;
      }

    }).filter(y => y != null);
    // console.log(foundKeys)
    return foundKeys.length === s.length;
  })

}


// const uniqueKeys = Array.from(new Set(foundKeys).values());
//       // console.log(uniqueKeys);
//       return uniqueKeys.length === s.length;
